import * as React from 'react';
import {Dispatch} from "redux";
import {connect} from "react-redux";

import {RouteComponentProps, withRouter} from "react-router-dom";
import {AppState} from "../store";
import {IFile} from "../store/files/types";
import {
    selectActiveFileData, selectActiveFileDataOriginal, selectFileDataById, selectIsActiveFileDataModified,
    selectSelectedFile,
} from "../store/files/selectors";
import FileData, {IFileDataProps} from "../components/FileSystem/FileData";
import {IFileData} from "../store/files/filedata/types";
import {
    fetchFileDataByIdAsyncActions,
    IModifyingActiveFileDataActionPayload,
    modifyingActiveFileDataAction, saveFileDataAsyncActions
} from "../store/files/filedata/actions";
import {Button} from "antd";
import {getFileParts} from "../components/FileSystem/constants";

interface IMatchParams {
}

interface IOwnProps extends RouteComponentProps<IMatchParams> {
    size?: number;
}

interface IStateProps {
    selectedFile?: IFile;
    activeFileData?: IFileData;
    activeFileDataOriginal?: IFileData;
    isActiveFileDataModified?: boolean;
}

interface IDispatchProps {
    modifyingActiveFileData: (value: IModifyingActiveFileDataActionPayload) => void;
    fetchFileDataByIdAsyncActions: (params: { id: string }) => void;
    saveFileDataAsyncActions: (params: { fileData: IFileData }) => void;
}

type IProps = IOwnProps & IStateProps & IDispatchProps;


const mapStateToProps = (state: AppState, props: IOwnProps): IStateProps => ({
    selectedFile: selectSelectedFile(state),
    activeFileData: selectActiveFileData(state),
    activeFileDataOriginal: selectActiveFileDataOriginal(state),
    isActiveFileDataModified: selectIsActiveFileDataModified(state),
});

const mapDispatchToProps = (
    dispatch: Dispatch
): IDispatchProps => {
    return {
        modifyingActiveFileData: (value: IModifyingActiveFileDataActionPayload) => dispatch(modifyingActiveFileDataAction(value)),
        fetchFileDataByIdAsyncActions: (params: { id: string }) => dispatch(fetchFileDataByIdAsyncActions.request(params)),
        saveFileDataAsyncActions: (params: { fileData: IFileData }) => dispatch(saveFileDataAsyncActions.request(params)),
    };
};

class FileDataContainer extends React.PureComponent<IProps> {
    componentDidMount(): void {
    }

    onFileDataChange = (data: string) => {
        if (this.props.modifyingActiveFileData) {
            this.props.modifyingActiveFileData({fileData: {data: data}})
        }
    }

    onSaveFileData = () => {
        if (this.props.saveFileDataAsyncActions && this.props.activeFileData) {
            this.props.saveFileDataAsyncActions({fileData: this.props.activeFileData})
        }
    }

    render() {
        // console.log("VariablesContainer render........")
        let fileDataProps: IFileDataProps = {} as IFileDataProps
        if (this.props.selectedFile && this.props.activeFileData) {
            const {name} = this.props.selectedFile
            const {ext} = getFileParts(name)

            fileDataProps = {
                size: this.props.size,
                activeFileData: this.props.activeFileData,
                originalFileData: this.props.activeFileDataOriginal,
                fileType: ext,
                onFileDataChange: this.onFileDataChange
            }
        }
        return (
            <React.Fragment>
                {
                    this.props.selectedFile && this.props.activeFileData ?
                        <React.Fragment>
                            <Button
                                onClick={this.onSaveFileData}
                                type="primary"
                                style={{marginBottom: 10, marginRight: 10}}
                                disabled={!this.props.isActiveFileDataModified}
                            >
                                Save File
                            </Button>
                            <span>{this.props.selectedFile.path}</span>
                            <FileData {...fileDataProps} />
                        </React.Fragment> : null
                }
            </React.Fragment>
        )
    }
}


export default withRouter(connect(
    mapStateToProps, mapDispatchToProps
)(FileDataContainer));


